import axiosInsAcademy from '@/api/axios-ugems-academy';
import axiosIns from '../axios';

export default {
  // Get attendance session details by token
  getAttendanceSession(token) {
    return axiosIns.get(`/validate-attendance-token`, {
      params: { token }
    });
  },

  // Get participants list for search
  getParticipants(token, company) {
    return axiosIns.get('/employees', {
      params: { token, company }
    });
  },

  // Get companies list for search
  getCompanies(token) {
    return axiosIns.get('/companies', {
      params: { token }
    });
  },

  // Submit attendance
  submitAttendance(data) {
    return axiosIns.post('/validate-attendance', data);
  }
};
